import { getSelectedHost } from "@tellescope/ui";
import { isDevelopment, isStaging } from "@tellescope/utils";

// API URL constants for different environments
export const STAGING_API_URL = "https://staging-api.tellescope.com";
export const TEST_API_URL = "http://localhost:8080";
export const PROD_API_URL = "https://api.tellescope.com";

// Function to determine the appropriate API URL based on the current environment
export const getApiURL = () => {
  if (isStaging()) return STAGING_API_URL;

  // In development, use the user-selected host if available
  if (isDevelopment()) {
    const selectedHost = getSelectedHost();
    return selectedHost.url;
  }

  return PROD_API_URL;
};
